import React, { useState } from "react";
import OpenConversation from "./OpenConversation";
import { useConversations } from "../contexts/ConversationsProvider";
import Conversations from "./Conversations";

export default function Dashboard({ id }) {
  const { selectedConversation, selectConversationIndex } = useConversations();
  const [isSelect, setIsSelect] = useState(false);

  const handleSelect = (select) => {
    setIsSelect(select);
    if (!select) {
      selectConversationIndex(-1);
    }
  };

  return (
    <div
      className="d-flex app"
      dir="rtl"
      style={{ height: "100%", minHeight: "100vh" }}
    >
      {isSelect === true && selectedConversation ? (
        <OpenConversation
          id={id}
          chatid={selectedConversation.chatid}
          setIsSelect={handleSelect}
        />
      ) : (
        <div style={{ width: "100%" }} className="d-flex">
          <Conversations id={id} setIsSelect={handleSelect} />
        </div>
      )}
    </div>
  );
}
